<template>
	<div class="footer">
		<div class="widthBox nav">
			<div class="item hidden-xs-only">
				<router-link to="/"  @click.native="set_nav_index(0)">
					<div class="logo"><img :src="info.web_info.web_footer_logo_url" alt=""></div>
				</router-link>
				<div class="f-12">{{ $t("PHROMON LIFE SCIENCES INTERNATIONAL is a global marketing company that offers a range of top-tier health and wellness products in the health industry from Australia.") }} </div>
				<a class="cursor btn" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a>
			</div>

			<div class="item" v-for="(item, index) in nav" :key="index">
				<div class="title">{{ item.name }}</div>
				<div class="txt f-12 cursor" v-for="(item2, index) in item.sub_nav_list" :key="index"
					@click="to_url(item2.url, item.head_nav_index)">{{ item2.name }}</div>
			</div>
			<div class="item">
				<div class="title">{{ $t("Contact Us") }} </div>
				<div class="txt f-12 center">
					<img v-if="!xs" src="@/assets/email.png" class="icon" alt="">
					<img v-if="xs" src="@/assets/email2.png" class="icon" alt="">
					<div>{{ $t("Enterprise email") }} ：<br> {{contact_us_info.products_after_sales_email}} </div>
				</div>
				<div class="txt f-12 center">
					<img v-if="!xs" src="@/assets/email.png" class="icon" alt="">
					<img v-if="xs" src="@/assets/email2.png" class="icon" alt="">
					<div>{{ $t("Products after-sales email") }}：<br>{{contact_us_info.enterprise_email}} </div>
				</div>
				<div class="txt f-12 center">
					<img v-if="!xs" src="@/assets/email.png" class="icon" alt="">
					<img v-if="xs" src="@/assets/email2.png" class="icon" alt="">
					<div>{{ $t("Member support email") }}：<br>{{contact_us_info.member_support_email}} </div>
				</div>
			</div>


		</div>
		<a class="cursor btn2 hidden-sm-and-up" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a>
		<div class="copyright">
			{{ info.web_info.record }}
		</div>
	</div>
</template>

<script>
export default {

	name: 'About',
	data() {
		return {
			xs: false,
			nav: this.$store.state.common.nav_list
		}
	},
	props: {
		info: {
			default: {},
			type: Object
		},
		nav: {
			default: [],
			type: Array
		},
		contact_us_info:{
			default:{}
		}
	},
	computed: {
		nav_list() {
			return this.$store.state.common.nav_list
		}
	},

	created() {
		if (window.innerWidth < 768) {
			this.xs = true
		}
		// console.log(window.innerWidth,this.xs )
	},
	mounted() {
		
	},
	methods: {

		topBtn() {
			document.body.scrollIntoView();
		},
		to_url(url, index) {
			console.log(url, index)
			this.$router.push(url)
			this.$store.state.head_nav_index = index
      		sessionStorage.setItem("head_nav_index",index)
			this.topBtn()
		},
		set_nav_index(index){
			document.body.scrollIntoView();
      		this.$store.state.head_nav_index = index;
      		sessionStorage.setItem("head_nav_index",index)
		}
	}
}
</script>


<style lang="scss" scoped="scoped">
.copyright {
	border-top: 1px solid #ccc;
	font-size: 10px;
	text-align: center;
	padding: 16px 0;
	color: #999;

}

.footer {
	background: #1A1A1A;
	// min-height: 312px;
	margin-top: 120px;
}

.title,
.f-12 {
	color: #fff;
}

.title {
	font-size: 14px;
	text-align: left;
	margin-bottom: 24px;
}

.center {
	display: flex;
}

.txt {
	color: #ccc;
	margin-bottom: 16px;
}

.icon {
	width: 16px;
	height: 16px;
	margin-right: 8px;
}

.logo {
	img {
		width: 136px;
		height: 40px;
	}

	width: 136px;
	height: 40px;
	margin-bottom: 12px;
}

.btn {
	padding: 12px 90px;
	border: 1px solid #fff;
	border-radius: 8px;
	margin-top: 20px;
	font-size: 14px;
	color: #fff;
	display: inline-block;
}

.nav {
	display: flex;
	justify-content: space-between;

	.item {
		width: 18%;
		margin-top: 40px;
	}

	.item:nth-child(1) {
		width: 30%;
	}
}

.btn2 {
	width: 100%;
	text-align: center;
	padding: 12px 0;
	display: block;
	color: #B50900;
	border: 1px solid #B50900;
	border-radius: 8px;
	text-align: center;
	margin-top: 20px;
	margin-bottom: 32px;
}

@media screen and(max-width:768px) {
	.widthBox {
		padding: 0 !important;
	}

	.nav {
		flex-wrap: wrap;

		.item {
			width: 100% !important;
			margin-top: 20px;
		}

		.item:nth-child(3) {
			border-bottom: 1px solid #e6e6e6;
		}
	}

	.title,
	.f-12 {
		color: #1A1A1A;
	}

	.title {
		font-size: 16px !important;
		margin-bottom: 16px;
	}

	.txt {
		color: #4D4D4D;
		font-size: 14px;
		margin-bottom: 12px;
	}

	.footer {
		background: none;
		// min-height: 312px;
		width: calc(100% - 40px);
		margin: 0 20px;
		margin-top: 56px;
		border-top: 1px solid #e6e6e6;
		box-sizing: border-box;
	}

	.copyright {
		font-size: 11px;
		color: #666;
		border: 0px;
		text-align: left;
	}
}</style>
